export default __webpack_public_path__ + "static/media/tuan.a475fb70.jpg";